const certificateActions: CommonActionTree<any> = {
  CHECK(_store, payload): Promise<UploadResponse> {
    return this.$api.upload('/api/v2/certificate/check', payload, {
      method: 'POST'
    });
  },
  VALIDATE(_store, payload): Promise<UploadResponse> {
    return this.$api.upload('/api/v2/certificate/validate', payload, {
      method: 'POST'
    });
  },
  VALIDATE_NO_DOMAIN(_store, payload): Promise<UploadResponse> {
    return this.$api.upload('/api/v2/certificate/validate-nodomain', payload, {
      method: 'POST'
    });
  },
};

export default new class implements CommonStore<any, unknown> {
  name = 'certificate';
  namespaced = true;
  actions = certificateActions;
}();
